// extracted by mini-css-extract-plugin
export default {"wideButton":"WideButton_wideButton__Pc-2L"};